// ========================================
// ================== V3 ==================
// ========================================

import * as aTypes from "./actionTypes";

// ============ MY USERS  ============
export const initFetchPlans = () => {
  return {
    type: aTypes.V3_PLANS_INIT,
  };
};

export const fetchPlansSuccess = (data) => {
  return {
    type: aTypes.V3_PLANS_SET,
    data: data,
  };
};

export const fetchPlansFail = (error) => {
  return {
    type: aTypes.V3_PLANS_FETCH_FAIL,
    error: error,
  };
};
